import api from './api';

export const userService = {
  // Obtener todos los usuarios (solo admin)
  async getUsers(params = {}) {
    try {
      const response = await api.get('/api/users', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener usuarios',
      };
    }
  },

  // Obtener un usuario por ID (solo admin)
  async getUser(id) {
    try {
      const response = await api.get(`/api/users/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener usuario',
      };
    }
  },

  // Crear nuevo usuario (solo admin)
  async createUser(userData) {
    try {
      const response = await api.post('/api/users', userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear usuario',
      };
    }
  },

  // Actualizar usuario (solo admin)
  async updateUser(id, userData) {
    try {
      const response = await api.put(`/api/users/${id}`, userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar usuario',
      };
    }
  },

  // Cambiar contraseña de usuario (solo admin)
  async changeUserPassword(id, newPassword) {
    try {
      const response = await api.put(`/api/users/${id}/change-password`, {
        newPassword,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cambiar contraseña',
      };
    }
  },

  // Activar/desactivar usuario (solo admin)
  async toggleUserStatus(id) {
    try {
      const response = await api.put(`/api/users/${id}/toggle-status`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al cambiar estado del usuario',
      };
    }
  },

  // Obtener actividad de usuario (solo admin)
  async getUserActivity(id, params = {}) {
    try {
      const response = await api.get(`/api/users/${id}/activity`, { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener actividad del usuario',
      };
    }
  },
}; 